import ClientLoggerFactory from "../../../logging/ClientLoggerFactory";
import { DataStore } from "aws-amplify";
import DataStoreDimensionDAO from "./DataStoreDimensionDAO";
import DimensionDAO from "../DimensionDAO";
import MockDataStoreDimensionDAO from "./MockDataStoreDimensionDAO";

export default class DataStoreDimensionDAOFactory {
    private static readonly INSTANCE: DimensionDAO = new DataStoreDimensionDAO(
        ClientLoggerFactory.getClientLogger("DataStoreDimensionDAO"),
        DataStore
    )
    private static readonly MOCK_INSTANCE: DimensionDAO = new MockDataStoreDimensionDAO(
        ClientLoggerFactory.getClientLogger("MockDataStoreDimensionDAO"),
    )

    public static getDimensionDAO() {
        if (process.env.REACT_APP_MOCK_ENABLED === "true") {
            return this.MOCK_INSTANCE;
        } else {
            return this.INSTANCE;
        }
    }
}
